let config = {
    BACKEND: "http://demo.thomas-lamson.com:7777/",
    // BACKEND: "http://localhost:7777/",
    MAX_CHARS: 10000,
}

export default config